module.exports = __webpack_public_path__ + "static/img/paypal-2.e31e0f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/paypal-2.png
// module id = p67u
// module chunks = 1